import { ObjectValues } from '$shared/helpers';

export const AUTH_FAILED_REASON = {
  unknown: 'unknown',
  popupBlocked: 'popup-blocked',
  rideError: 'ride-error',
  originInvalid: 'origin-invalid',
} as const;

export type AuthFailReason = ObjectValues<typeof AUTH_FAILED_REASON>;
